import React, {useRef, useEffect} from 'react'
import { useSelector } from 'react-redux'
import parse, { attributesToProps, domToReact } from 'html-react-parser';
import RenderedHtmlContent from '../rendered_html_content'
import useMediaQuery from "@material-ui/core/useMediaQuery";

export default function RawHtmlPreview({data, onModalClose, dialogOnClick}) {
  let html = ""

  const tagOwner = useSelector(state => state.tagOwner)
  const guestListEntries = useSelector(state => state.guestListEntries)
  const events = useSelector(state => state.events)
  const hostname = useSelector(state => state.hostname)
  const ref = useRef(null)
  const isMobile = useMediaQuery('(max-width:995px)');

  useEffect(() => {
    if(hostname != "flaveiot20" && window.pageYOffset > ref.current.offsetTop) {
      console.log("ref.current.scrollTop", document.body.scrollTop, document.body.scrollTop, window.pageXOffset, window.pageYOffset)
      ref.current.setAttribute("style", "top: " + String(window.pageYOffset + 10) + "px")
    }
  }, [])

  if (data.iframe_html) {
    html = data.iframe_html
  }

  if(tagOwner && tagOwner.id) {
    html = html.replace(/@tag_owner_id@/g, tagOwner.id)
  }
  const placeholders = {tagOwner: tagOwner, guestListEntries: guestListEntries, events: events}

  return <div className="modal preview-modal" role="dialog" tabIndex="-1"
              onClick={() => {
                onModalClose ? onModalClose() : alert("No modal close action available.")
              }}>
    <div className="modal-dialog" ref={ref} role="document">
      <div className="modal-content" onClick={(event) => { dialogOnClick ? dialogOnClick() : event.stopPropagation() }} ref={ref} role="document">
        <div className="modal-header">
          <div className="modal-title">
            {data.title}
          </div>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              onModalClose ? onModalClose() : alert("No modal close action available.")
            }}>
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <RenderedHtmlContent html={html} placeholders={placeholders}/>
        </div>
      </div>
    </div>
  </div>
}
